import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpInterceptor} from '@angular/common/http';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { GLOBAL } from '../../global/global';
import { LoginService } from 'app/main/login/login.service';

import { User } from '../../models/users.model';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ',
    })
};


@Injectable({
    providedIn: 'root'
})
export class UsuariosService implements Resolve<any>
{
    public urlAPI: string;
    dataAll: any[];
    onOrdersChanged: BehaviorSubject<any>;

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient,
        private _loginService: LoginService,
        private _router: Router
    )
    {
        // Set the defaults
        this.onOrdersChanged = new BehaviorSubject({});
        this.urlAPI = GLOBAL.url;
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {

            Promise.all([
                this.getData()
            ]).then(
                () => {
                    resolve();
                },
                () => {
                    reject();
                }

            );
        });
    }

    /**
     * Get dataAll
     *
     * @returns {Promise<any>}
     */
    getData(): Promise<any>
    {
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'session/users', httpOptions)
                .subscribe(
                    (response: any) => {
                        this.dataAll = response.data.users;
                        this.onOrdersChanged.next(this.dataAll);
                        resolve(response);
                 },
                    (responseError: any) => {
                        reject(responseError);
                    });
        });
    }

    /**
     * Save a new User
     * @param token
     * @param car
     */
    create(data): Promise<any>{
        const json = JSON.stringify(data);
        const myData = {
            data: {
                user: data
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        // return this._httpClient.post(this.urlAPI + 'session/users', myParam, httpOptions);

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.urlAPI + 'session/users', myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Get data of a User
     * @param token
     * @param car
     */
    getOne(id): Promise<any>{
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        // return this._httpClient.post(this.urlAPI + 'session/users', myParam, httpOptions);

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.urlAPI + 'session/users/' + id, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Update a new User
     * @param token
     * @param car
     */
    update(data): Promise<any>{
        const json = JSON.stringify(data);
        const myData = {
            data: {
                user: data
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());
        // return this._httpClient.post(this.urlAPI + 'session/users', myParam, httpOptions);

        return new Promise((resolve, reject) => {
            this._httpClient.put(this.urlAPI + 'session/users/' + data.id, myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });
    }

    /**
     * Delete a user
     * @param id
     * @returns {Promise<T>}
     */
    delete(id): Promise<any>{
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.delete(this.urlAPI + 'session/users/' + id, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Activate the user
     * @param id
     * @param type
     * @returns {Promise<T>}
     */
    activate(id, type): Promise<any>{
        const myData = {
        };
        const myParam = JSON.stringify(myData);

        let httpOptions2 = httpOptions;
        httpOptions2.headers = httpOptions2.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.put(this.urlAPI + 'session/users/activate/' + id + '/' + type, myParam, httpOptions2).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });

    }

    /**
     * Update a new User
     * @param token
     * @param car
     */
    setPassword(data): Promise<any>{
        const json = JSON.stringify(data);
        const myData = {
            data: {
                user: data
            }
        };
        const myParam = JSON.stringify(myData);

        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this._loginService.getToken());

        return new Promise((resolve, reject) => {
            this._httpClient.put(this.urlAPI + 'session/users/password/' + data.id, myParam, httpOptions).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (error: any) => {
                    reject(error);
                });
        });
    }

}
